<template>
    <p-inc-mail-menu-content
        :items         = "units"
        :selected-item = "selected"
        item-label     = "Anlage"
        item-text      = "fabricNo"
        :width         = "500"
        @search        = "onSearch"
        @selected      = "onUnit"
    >
        <template v-slot:item="{ item }">
            <div class="v-flex">
                <div style="width: 100px;">
                    {{ item.fabricNo }}
                </div>
            </div>
            <div>
                {{ unitAsString(item) }}
            </div>
        </template>
        <template v-slot:selection="{ item }">
            {{ item.fabricNo }} - {{ unitAsString(item) }}
        </template>

        <template v-slot:content>
            <div class="pa-3 pl-4 pr-1">
                <div class="mt-1">
                    <p-inc-selectable-document
                        v-for     = "(document,index) in filteredDocuments"
                        :key      = "index"
                        :document = "document"
                        class     = "border-style"
                        :class    = "border(index)"
                        :selected = "isSelected(document)"
                        @selected = "onSelected"
                    />
                </div>
            </div>
            <div v-if="!filteredDocuments || filteredDocuments.length === 0" class="mail-empty-documents error--text">
                {{ empty }}
            </div>
        </template>
    </p-inc-mail-menu-content>
</template>

<script>

import Dms                    from "@/modules/dms/common/service/Dms";
import PIncMailMenuContent    from "@/modules/inc/mail/private/PIncMailMenuContent.vue";
import PIncSelectableDocument from "@/modules/inc/mail/private/PIncSelectableDocument.vue";
import PIncDocumentsMixin     from "@/modules/inc/mail/private/PIncDocumentsMixin";
import Core from "@/modules/core/service/Core";

export default {

    name: "PIncUnitDocuments",

    components: {
        PIncSelectableDocument,
        PIncMailMenuContent
    },

    mixins: [
        PIncDocumentsMixin
    ],

    props: {
        unit: {

        },

        units: {

        },

        type: {

        },
    },

    data: () => ({
        selected : null,
        documents: null,
        filteredDocuments: null,
    }),

    computed: {
        empty () {
            switch (this.type) {
                case "MAINTENANCE":
                    return this.$t('mail.maintenance.empty');
                case "ASSESSMENT":
                    return this.$t('mail.assessment.empty');
                default:
                    return null;
            }
        }
    },

    mounted() {
        this.initialize();
    },

    watch: {
        unit () {
            this.onUnit(this.unit);
        },

        units () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            if (!this.units || !this.unit) {
                return;
            }

            this.onUnit(this.units.find (u => u.id === this.unit.id));
        },

        onSearch (text) {
            if (!text) {
                this.filteredDocuments = this.documents;
                return;
            }

            this.filteredDocuments = this.documents.filter (d => Core.filter.includes(d.name, text));
        },

        onUnit (unit) {
            this.selected = unit;
            Dms.unitDocuments(this.selected.id, this.type).then (data => {
                this.documents = data;
                this.filteredDocuments = this.documents;
            });
        },

        unitAsString (unit) {
            return unit.zip + " " + unit.city + ", " + unit.street;
        },
    }
}

</script>

<style scoped>

.border-style {
    border-style: solid;
    border-color: lightgray;
    border-width: 1px;
}

.mail-empty-documents {
    padding-left: 16px;
    text-align: center;
    padding-bottom: 12px;
}

</style>